import colors from '../../colors';
import { media, withMedia, WithMediaProps } from '../../../util/styles';
import * as React from 'react';
import styled from 'styled-components';
import * as CloseIcon from 'react-icons/lib/io/close-round';
import * as MinusIcon from 'react-icons/lib/io/minus-round';

interface Props extends WithMediaProps {
    onMinimize?: (e: React.MouseEvent<HTMLElement>) => any;
    onClose?: (e: React.MouseEvent<HTMLElement>) => any;
}

const IconBar: React.SFC<Props> = ({ onMinimize, onClose, isMobile }) => (
    <IconsWrapper>
        {onMinimize && (
            <IconWrapper color="#ffcc00">
                <a href="#" onClick={onMinimize}>
                    <MinusIcon size={isMobile ? 16 : 12} />
                </a>
            </IconWrapper>
        )}
        {onClose && (
            <IconWrapper>
                <a href="#" onClick={onClose}>
                    <CloseIcon size={isMobile ? 16 : 12} />
                </a>
            </IconWrapper>
        )}
    </IconsWrapper>
);

export const BaseIconBar = IconBar;
export default withMedia(IconBar);

const IconsWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    a {
        color: ${colors.white};
    }
`;
const IconWrapper = styled.div`
    margin-left: 1em;
    border-radius: 50%;
    cursor: pointer;
    background-color: ${props => props.color || colors.red};
    box-shadow: 0 1.5px 2.5px 0 rgba(0, 0, 0, 0.5);
    border: 1px solid ${colors.white};
    color: ${colors.white};
    width: 18px;
    height: 18px;
    font-size: 8px;
    line-height: 1;
    display: flex;
    padding: 0;
    align-items: center;
    justify-content: center;
    transition: all 0.1s ease-in;
    &:focus {
        outline: none;
    }
    &:hover {
        transform: scale(1.1);
    }
    ${media.mobile`
        border-width: 2px;
        width: 24px;
        height: 24px;
    `};
`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Conversation/Proactive/IconBar.tsx